import { render, staticRenderFns } from "./carTab.vue?vue&type=template&id=084d2170&scoped=true"
import script from "./carTab.vue?vue&type=script&lang=js"
export * from "./carTab.vue?vue&type=script&lang=js"
import style0 from "./carTab.vue?vue&type=style&index=0&id=084d2170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084d2170",
  null
  
)

export default component.exports